import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function ServicesSection() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-computer-line',
      titleKey: 'services.websites.title',
      descKey: 'services.websites.description',
      gradient: 'from-cyan-500 to-blue-600',
      link: '/websites'
    },
    {
      icon: 'ri-palette-line',
      titleKey: 'services.branding.title',
      descKey: 'services.branding.description',
      gradient: 'from-blue-600 to-purple-600',
      link: null
    },
    {
      icon: 'ri-printer-line',
      titleKey: 'services.printing.title',
      descKey: 'services.printing.description',
      gradient: 'from-purple-600 to-pink-600',
      link: null
    },
    {
      icon: 'ri-customer-service-2-line',
      titleKey: 'services.itSupport.title',
      descKey: 'services.itSupport.description',
      gradient: 'from-pink-600 to-cyan-500',
      link: null
    }
  ];

  const handleServiceClick = (link: string | null) => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => handleServiceClick(service.link)}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Icon */}
              <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.gradient} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {t(service.titleKey)}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {t(service.descKey)}
              </p>

              {/* Hover Effect */}
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}